export default "__VITE_ASSET__iVbeEYFs__"